import { MESApiService, ResponseMESF, spParameter } from "@dexteel/mesf-core";
import { ASSET_IDS } from "@/utils/constants";

const STORED_PROCEDURES: { [key: number]: string } = {
  [ASSET_IDS.EAF]: "[EAF].[GetProcessesByDateRange]",
  [ASSET_IDS.LMF]: "[LMF].[GetProcessesByDateRange]",
  [ASSET_IDS.CASTER]: "[CAS].[GetProcessesByDateRange]",
};

const UPSERT_PROCEDURES: { [key: number]: string } = {
  [ASSET_IDS.EAF]: "[EAF].[UpsertProcessData]",
  [ASSET_IDS.LMF]: "[LMF].[UpsertProcessData]",
  [ASSET_IDS.CASTER]: "[CAS].[UpsertProcessData]",
};

export const getProcessesByDateRange = async (
  start: Date,
  end: Date,
  assetId: number,
): Promise<ResponseMESF> => {
  const apiService = new MESApiService();
  let sqlParameters = [];
  sqlParameters.push({ name: "Start", value: start.toISOString() });
  sqlParameters.push({ name: "End", value: end.toISOString() });

  const procedure = STORED_PROCEDURES[assetId];
  if (!procedure) {
    throw new Error(`Unsupported asset ID: ${assetId}`);
  }

  return await apiService.callV2(procedure, sqlParameters);
};

export const upsertProcessData = async (
  processId: number,
  field: string,
  value: any,
  assetId: number,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });
  parameters.push({ name: field, value: value });
  parameters.push({ name: "IsManual", value: true });

  const procedure = UPSERT_PROCEDURES[assetId];
  if (!procedure) {
    throw new Error(`Unsupported asset ID: ${assetId}`);
  }

  return await apiService.callV2(procedure, parameters);
};
